import React, { ReactNode } from "react";
import styles from "./drop-area-deactivation-overlay-container.module.scss";
import cn from "classnames";
import { useSelector } from "react-redux";
import { RootState } from "@src/reducers/store";

interface DropAreaDeactivationOverlayContainerPropTypes {
  children: ReactNode;
}

const cssClassName = "drop-area-deactivation-overlay-container";

export const DropAreaDeactivationOverlayContainer = ({
  children,
}: DropAreaDeactivationOverlayContainerPropTypes) => {
  const showDropAreaDeactivationOverlayState = useSelector(
    (state: RootState) => state.yourSlice.showDropAreaDeactivationOverlay,
  );

  return (
    <div
      className={cn(styles[cssClassName], {
        [styles[`${cssClassName}--activate`]]:
          showDropAreaDeactivationOverlayState,
      })}
    >
      {children}
    </div>
  );
};
